import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { Component, isValidElement } from 'react';
import { safeInvoke } from '../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Overlay from '../Overlay';
import Form from '../Form';
import Button from '../Button';
import Translate from '../Translate';

var isProps = function isProps(value) {
  return value && _typeof(value) === 'object' && !isValidElement(value);
};
/**
 * `Dialog` is a modal window that asks users to make a decision or enter additional information.
 * @since 0.0.68
 */


var Dialog =
/*#__PURE__*/
function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: _this.props.isOpen
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        show: false
      });

      safeInvoke(_this.props.onClose);
    });

    return _this;
  }

  _createClass(Dialog, [{
    key: "renderImage",
    value: function renderImage(image, block) {
      var baseClassName = this.props.baseClassName;
      var classPrefix = "".concat(baseClassName, "__").concat(block);

      if (isValidElement(image)) {
        return React.createElement("div", {
          className: classPrefix
        }, image);
      }

      if (typeof image === 'string') {
        return React.createElement("div", {
          className: classPrefix
        }, React.createElement("img", {
          className: "".concat(classPrefix, "-inner"),
          src: image
        }));
      }

      return React.createElement("div", {
        className: classPrefix
      }, React.createElement("img", _extends({
        className: "".concat(classPrefix, "-inner")
      }, image)));
    }
  }, {
    key: "getCancelButtonProps",
    value: function getCancelButtonProps() {
      var _this$props = this.props,
          closable = _this$props.closable,
          cancelTitle = _this$props.cancelTitle,
          cancelButton = _this$props.cancelButton,
          form = _this$props.form;

      if (!closable) {
        return false;
      }

      if (cancelButton === false || form && form.cancelButton === false) {
        return false;
      }

      var props = {
        onClick: this.handleClose,
        children: cancelTitle || React.createElement(Translate, {
          content: "Dialog.cancelButton",
          fallback: "Cancel"
        })
      };

      if (form && isProps(form.cancelButton)) {
        props = _objectSpread({}, props, {}, form.cancelButton);
      }

      if (isProps(cancelButton)) {
        props = _objectSpread({}, props, {}, cancelButton);
      }

      return props;
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var form = this.props.form;

      if (form) {
        return null;
      }

      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          buttons = _this$props2.buttons;
      var cancel;
      var cancelButtonProps = this.getCancelButtonProps();

      if (cancelButtonProps) {
        cancel = React.createElement(Button, cancelButtonProps);
      }

      if (buttons || cancel) {
        return React.createElement("div", {
          className: "".concat(baseClassName, "__buttons")
        }, buttons, cancel);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          baseClassName = _this$props3.baseClassName,
          className = _this$props3.className,
          children = _this$props3.children,
          actions = _this$props3.actions,
          isOpen = _this$props3.isOpen,
          banner = _this$props3.banner,
          image = _this$props3.image,
          title = _this$props3.title,
          cancelTitle = _this$props3.cancelTitle,
          cancelButton = _this$props3.cancelButton,
          buttons = _this$props3.buttons,
          form = _this$props3.form,
          size = _this$props3.size,
          closable = _this$props3.closable,
          onClose = _this$props3.onClose,
          props = _objectWithoutProperties(_this$props3, ["baseClassName", "className", "children", "actions", "isOpen", "banner", "image", "title", "cancelTitle", "cancelButton", "buttons", "form", "size", "closable", "onClose"]);

      var show = this.state.show;
      var childrenElement;

      if (form) {
        form.cancelButton = this.getCancelButtonProps();
        form.footerClassName = classNames(form.footerClassName, "".concat(baseClassName, "__form-footer"));
        form.applyButton = form.applyButton || false;
        childrenElement = React.createElement(Form, form, children);
      } else {
        childrenElement = children;
      }

      return React.createElement(Overlay, _extends({
        className: classNames(baseClassName, className),
        isOpen: show,
        onClose: this.handleClose,
        canCloseOnBackdropClick: false,
        canCloseOnEscapePress: closable,
        size: size
      }, props), (title || actions) && React.createElement("header", {
        className: "".concat(baseClassName, "__heading"),
        "data-skip-auto-focus": true
      }, title && React.createElement("h2", {
        className: "".concat(baseClassName, "__heading-title")
      }, title), actions && React.createElement("div", {
        className: "".concat(baseClassName, "__heading-actions")
      }, actions), closable && React.createElement(Button, {
        className: "".concat(baseClassName, "__heading-close"),
        ghost: true,
        icon: "cross-mark",
        onClick: this.handleClose
      })), banner && this.renderImage(banner, 'banner'), React.createElement("div", {
        className: "".concat(baseClassName, "__content")
      }, image && this.renderImage(image, 'image'), childrenElement, this.renderButtons()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var isOpen = props.isOpen;
      var prevIsOpen = state.prevIsOpen;
      var nextState = {};

      if (isOpen !== prevIsOpen) {
        nextState.show = isOpen;
      }

      nextState.prevIsOpen = isOpen;
      return nextState;
    }
  }]);

  return Dialog;
}(Component);

Dialog.propTypes = {
  /**
   * Toggles visibility.
   * @since 0.0.68
   */
  isOpen: PropTypes.bool,

  /**
   * Banner. Renders in front of content as wide as dialog.
   * @since 0.0.68
   */
  banner: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),

  /**
   * Image. Renders into content.
   * @since 0.0.68
   */
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),

  /**
   * Title
   * @since 0.0.68
   */
  title: PropTypes.node,

  /**
   * Title of "cancel" button
   * @since 0.0.68
   * @deprecated Use `cancelButton` instead.
   */
  cancelTitle: PropTypes.node,

  /**
   * Cancel button visibility or custom configuration. It accepts all props of the `Button` component.
   * @since 3.13.0
   */
  cancelButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  /**
   * Buttons except "cancel" button
   * @since 0.0.68
   */
  buttons: PropTypes.node,

  /**
   * Actions which will be shown in Dialog header
   * @since 1.2.0
   */
  actions: PropTypes.node,

  /**
   * Wraps children into [Form](#!/Form) if not empty.
   * @since 0.0.68
   */
  form: PropTypes.object,

  /**
   * Dialog width
   * @since 0.0.68
   */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /**
   * If the value is false, the dialog cannot be closed and the Close button is hidden.
   * @since 1.2.0
   */
  closable: PropTypes.bool,

  /**
   * On close event handler. Called immediately after dialog closed by "cancel" button or "Esc" key.
   * @since 0.0.68
   */
  onClose: PropTypes.func,

  /**
   * Content of the `DialogWindow`.
   * @since 0.0.68
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Dialog.defaultProps = {
  isOpen: false,
  banner: undefined,
  image: undefined,
  title: undefined,
  cancelTitle: undefined,
  cancelButton: undefined,
  buttons: undefined,
  actions: undefined,
  form: undefined,
  size: 'md',
  closable: true,
  onClose: undefined,
  children: undefined,
  className: undefined,
  baseClassName: "".concat(CLS_PREFIX, "dialog")
};
export default Dialog;